import styled, { FlattenSimpleInterpolation } from 'styled-components'

import { breakpoints, colors, fontSizes } from '@/styles'

export const Title = styled.h1`
  padding: 0;
  margin: 0;
  font-size: 50px;
  line-height: 62px;
  font-weight: 700;
  margin-bottom: 20px;
  ${props =>
    props.color &&
    `
    color: ${props.color};
  `}

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    font-size: 38px;
  }
`

export const Container = styled.main`
  display: flex;
  justify-content: center;
  max-width: 940px;
  align-items: flex-start;
  margin: 0 auto;
  padding: 50px;
  width: 100%;

  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    flex-direction: column;
    margin-top: 0;
    padding: 50px 25px;
  }
`

export const PageContainer = styled.section`
  width: 75%;

  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    width: 100%;
  }
`

export const Wrapper = styled.div`
  margin-left: 16px;
  margin: 28px 0 20px 16px;
`

export const Paragraph = styled.p`
  text-indent: -16px;
  margin-bottom: 20px;
`

export const List = styled.ul`
  list-style: none;
  text-indent: -16px;
  margin-bottom: 20px;
`

export const ParagraphHeader = styled.h4`
  text-indent: -20px;
  font-size: 16px;
`

export const Spacer = styled.span<{ height: string }>`
  display: block;
  height: ${props => props.height};
`

export const PolicyWrapper = styled.div<{
  customStyle?: FlattenSimpleInterpolation
}>`
  ${({ customStyle }) => customStyle}

  .section-heading {
    font-size: ${fontSizes.large};
    line-height: 28px;
    font-weight: 700;
    margin-top: 45px;
    margin-bottom: 25px;
  }
  .sub-heading,
  .sub-sub-heading {
    font-size: ${fontSizes.regularMobile};
    line-height: 20px;
    font-weight: 700;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  p {
    font-size: ${fontSizes.small};
  }

  a[href] {
    font-size: ${fontSizes.small};
    text-decoration: none;
    color: ${colors.link};

    &.summary-link {
      padding-bottom: 10px;
      display: block;
    }
  }

  a[href=''] {
    font-size: inherit;
    color: inherit;
  }

  li {
    font-size: ${fontSizes.small};
    margin-bottom: 10px;
  }

  .jumplink:before {
    content: '';
    display: block;
    position: relative;
    width: 0;
    height: 110px;
    margin-top: -110px;
  }
`
